export enum AttachmentType{
	DOC = 'DOC',
	DOCX = 'DOCX',
	ODT = 'ODT',
	TXT = 'TXT',
	CSV = 'CSV',
	ODS = 'ODS',
	PDF = 'PDF',
	XLS = 'XLS',
	XLSX = 'XLSX',
	PPT = 'PPT',
	PPTX = 'PPTX',
	ODP = 'ODP',
	JPG = 'JPG',
	PNG = 'PNG',
	JPEG = 'JPEG',
	P7M = 'P7M',
}
